// extracted by mini-css-extract-plugin
export default {"form":"AddAuthorizedPersonModal_form__wtEef","footer":"AddAuthorizedPersonModal_footer__+0rpo"};